import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
    apiKey: "AIzaSyDtYSsH7q3RLIGXyYjMJFx0DPgGICLSNS0",
    authDomain: "storecreditapp.firebaseapp.com",
    projectId: "storecreditapp",
    storageBucket: "storecreditapp.firebasestorage.app",
    messagingSenderId: "681388039799",
    appId: "1:681388039799:web:7ca21796809cef729cf072",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
// Configure functions for the correct region where they are deployed
export const functions = getFunctions(app, 'us-central1');

export default app;